/* eslint-disable */
// @generated by protobuf-ts 2.8.2 with parameter generate_dependencies,add_pb_suffix,use_proto_field_name,ts_nocheck,eslint_disable
// @generated from protobuf file "brandguard.document.proto" (package "brandguard.document", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { DocumentKernelSetting } from "./brandguard.kernel_pb";
import { KernelMetadata } from "./brandguard.kernel_pb";
import { Keyset } from "./meta.search_pb";
import { FloatRange } from "./meta.search_pb";
import { DateRange } from "./meta.search_pb";
import { Prediction } from "./brandguard.approval_pb";
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentEvent
 */
export interface DocumentEvent {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string account_id = 2 [json_name = "account_id"];
     */
    account_id: string;
    /**
     * @generated from protobuf field: string brand_id = 3 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: brandguard.approval.Prediction approved = 4;
     */
    approved: Prediction;
    /**
     * @generated from protobuf field: brandguard.approval.Prediction observation = 5;
     */
    observation: Prediction;
    /**
     * @generated from protobuf field: string queue = 6;
     */
    queue: string;
    /**
     * @generated from protobuf field: double confidence = 1000;
     */
    confidence: number;
    /**
     * @generated from protobuf field: int32 page_count = 1001 [json_name = "page_count"];
     */
    page_count: number;
    /**
     * @generated from protobuf field: int32 pages_scored = 1002 [json_name = "pages_scored"];
     */
    pages_scored: number;
    /**
     * @generated from protobuf field: string updated_at = 1003 [json_name = "updated_at"];
     */
    updated_at: string;
    /**
     * @generated from protobuf field: double doc_brand_voice = 1004 [json_name = "doc_brand_voice"];
     */
    doc_brand_voice: number;
    /**
     * @generated from protobuf field: double doc_nudity = 1005 [json_name = "doc_nudity"];
     */
    doc_nudity: number;
    /**
     * @generated from protobuf field: double doc_violence = 1006 [json_name = "doc_violence"];
     */
    doc_violence: number;
    /**
     * @generated from protobuf field: double doc_racism = 1007 [json_name = "doc_racism"];
     */
    doc_racism: number;
    /**
     * @generated from protobuf field: double doc_grammar = 1008 [json_name = "doc_grammar"];
     */
    doc_grammar: number;
    /**
     * @generated from protobuf field: double doc_lookandfeel = 1009 [json_name = "doc_lookandfeel"];
     */
    doc_lookandfeel: number;
    /**
     * @generated from protobuf field: double doc_logo_detection = 1010 [json_name = "doc_logo_detection"];
     */
    doc_logo_detection: number;
    /**
     * @generated from protobuf field: double doc_font_detection = 1011 [json_name = "doc_font_detection"];
     */
    doc_font_detection: number;
    /**
     * @generated from protobuf field: double doc_rules = 1012 [json_name = "doc_rules"];
     */
    doc_rules: number;
    /**
     * @generated from protobuf field: double artifact_score = 1013 [json_name = "artifact_score"];
     */
    artifact_score: number;
    /**
     * @generated from protobuf field: string artifact_match_description = 1014 [json_name = "artifact_match_description"];
     */
    artifact_match_description: string;
    /**
     * @generated from protobuf field: string artifact_match_training_id = 1015 [json_name = "artifact_match_training_id"];
     */
    artifact_match_training_id: string;
    /**
     * @generated from protobuf field: double doc_ai_generated = 1016 [json_name = "doc_ai_generated"];
     */
    doc_ai_generated: number;
    /**
     * @generated from protobuf field: string doc_ai_generated_explanation = 1017 [json_name = "doc_ai_generated_explanation"];
     */
    doc_ai_generated_explanation: string;
    /**
     * @generated from protobuf field: double doc_background_colors = 1018 [json_name = "doc_background_colors"];
     */
    doc_background_colors: number;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentMedia
 */
export interface DocumentMedia {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string account_id = 2 [json_name = "account_id"];
     */
    account_id: string;
    /**
     * @generated from protobuf field: string brand_id = 3 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: string uploaded_by = 4 [json_name = "uploaded_by"];
     */
    uploaded_by: string;
    /**
     * @generated from protobuf field: string md5 = 5;
     */
    md5: string;
    /**
     * @generated from protobuf field: string mimetype = 6;
     */
    mimetype: string;
    /**
     * @generated from protobuf field: string mimetype_md5 = 7 [json_name = "mimetype_md5"];
     */
    mimetype_md5: string;
    /**
     * @generated from protobuf field: string created_at = 8 [json_name = "created_at"];
     */
    created_at: string;
    /**
     * @generated from protobuf field: string updated_at = 9 [json_name = "updated_at"];
     */
    updated_at: string;
    /**
     * @generated from protobuf field: string tombstoned_at = 10 [json_name = "tombstoned_at"];
     */
    tombstoned_at: string;
    /**
     * @generated from protobuf field: string scored_at = 11 [json_name = "scored_at"];
     */
    scored_at: string;
    /**
     * @generated from protobuf field: string description = 12;
     */
    description: string;
    /**
     * @generated from protobuf field: int32 page_count = 13 [json_name = "page_count"];
     */
    page_count: number;
    /**
     * @generated from protobuf field: int32 pages_scored = 14 [json_name = "pages_scored"];
     */
    pages_scored: number;
    /**
     * @generated from protobuf field: string reviewed_by = 15 [json_name = "reviewed_by"];
     */
    reviewed_by: string;
    /**
     * @generated from protobuf field: string ancestor_id = 16 [json_name = "ancestor_id"];
     */
    ancestor_id: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentPage
 */
export interface DocumentPage {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string document_id = 2 [json_name = "document_id"];
     */
    document_id: string;
    /**
     * @generated from protobuf field: string account_id = 3 [json_name = "account_id"];
     */
    account_id: string;
    /**
     * @generated from protobuf field: string brand_id = 4 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: string uploaded_by = 5 [json_name = "uploaded_by"];
     */
    uploaded_by: string;
    /**
     * @generated from protobuf field: int32 page_number = 6 [json_name = "page_number"];
     */
    page_number: number;
    /**
     * @generated from protobuf field: string created_at = 7 [json_name = "created_at"];
     */
    created_at: string;
    /**
     * @generated from protobuf field: string updated_at = 8 [json_name = "updated_at"];
     */
    updated_at: string;
    /**
     * @generated from protobuf field: string scored_at = 9 [json_name = "scored_at"];
     */
    scored_at: string;
    /**
     * @generated from protobuf field: brandguard.approval.Prediction approved = 10;
     */
    approved: Prediction;
    /**
     * @generated from protobuf field: brandguard.approval.Prediction observation = 11;
     */
    observation: Prediction;
    /**
     * @generated from protobuf field: double confidence = 12;
     */
    confidence: number;
    /**
     * @generated from protobuf field: double doc_brand_voice = 13 [json_name = "doc_brand_voice"];
     */
    doc_brand_voice: number;
    /**
     * @generated from protobuf field: double doc_nudity = 14 [json_name = "doc_nudity"];
     */
    doc_nudity: number;
    /**
     * @generated from protobuf field: double doc_violence = 15 [json_name = "doc_violence"];
     */
    doc_violence: number;
    /**
     * @generated from protobuf field: double doc_racism = 16 [json_name = "doc_racism"];
     */
    doc_racism: number;
    /**
     * @generated from protobuf field: double doc_grammar = 17 [json_name = "doc_grammar"];
     */
    doc_grammar: number;
    /**
     * @generated from protobuf field: double doc_lookandfeel = 18 [json_name = "doc_lookandfeel"];
     */
    doc_lookandfeel: number;
    /**
     * @generated from protobuf field: double doc_logo_detection = 19 [json_name = "doc_logo_detection"];
     */
    doc_logo_detection: number;
    /**
     * @generated from protobuf field: double doc_font_detection = 20 [json_name = "doc_font_detection"];
     */
    doc_font_detection: number;
    /**
     * @generated from protobuf field: double doc_rules = 21 [json_name = "doc_rules"];
     */
    doc_rules: number;
    /**
     * @generated from protobuf field: string page_image_path = 22 [json_name = "page_image_path"];
     */
    page_image_path: string;
    /**
     * @generated from protobuf field: double doc_ai_generated = 23 [json_name = "doc_ai_generated"];
     */
    doc_ai_generated: number;
    /**
     * @generated from protobuf field: string doc_ai_generated_explanation = 24 [json_name = "doc_ai_generated_explanation"];
     */
    doc_ai_generated_explanation: string;
    /**
     * @generated from protobuf field: double doc_background_colors = 25 [json_name = "doc_background_colors"];
     */
    doc_background_colors: number;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentUploadRequest
 */
export interface DocumentUploadRequest {
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentUploadResponse
 */
export interface DocumentUploadResponse {
    /**
     * @generated from protobuf field: brandguard.document.DocumentMedia media = 1;
     */
    media?: DocumentMedia;
    /**
     * @generated from protobuf field: brandguard.document.DocumentEvent event = 2;
     */
    event?: DocumentEvent;
    /**
     * @generated from protobuf field: repeated brandguard.document.DocumentPage pages = 3;
     */
    pages: DocumentPage[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentSearchRequest
 */
export interface DocumentSearchRequest {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: repeated string queues = 2;
     */
    queues: string[];
    /**
     * @deprecated
     * @generated from protobuf field: string deprecated_uploaded_by = 3 [deprecated = true, json_name = "uploaded_by"];
     */
    deprecated_uploaded_by: string;
    /**
     * @generated from protobuf field: string brand_id = 4 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: meta.DateRange created = 5;
     */
    created?: DateRange;
    /**
     * @generated from protobuf field: uint64 limit = 6;
     */
    limit: bigint;
    /**
     * @generated from protobuf field: repeated brandguard.approval.Prediction observation = 7;
     */
    observation: Prediction[];
    /**
     * @generated from protobuf field: repeated brandguard.approval.Prediction approved = 8;
     */
    approved: Prediction[];
    /**
     * @generated from protobuf field: meta.FloatRange confidence = 9;
     */
    confidence?: FloatRange;
    /**
     * @generated from protobuf field: repeated string uploaded_by = 10 [json_name = "uploaders"];
     */
    uploaded_by: string[];
    /**
     * @generated from protobuf field: meta.Keyset before = 11;
     */
    before?: Keyset; // only results older than this position
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentSearchResponseItem
 */
export interface DocumentSearchResponseItem {
    /**
     * @generated from protobuf field: brandguard.document.DocumentMedia media = 1;
     */
    media?: DocumentMedia;
    /**
     * @generated from protobuf field: brandguard.document.DocumentEvent event = 2;
     */
    event?: DocumentEvent;
    /**
     * @generated from protobuf field: repeated brandguard.document.DocumentPage pages = 3;
     */
    pages: DocumentPage[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentSearchResponse
 */
export interface DocumentSearchResponse {
    /**
     * @generated from protobuf field: repeated brandguard.document.DocumentSearchResponseItem items = 1;
     */
    items: DocumentSearchResponseItem[];
    /**
     * @generated from protobuf field: brandguard.document.DocumentSearchRequest next = 2;
     */
    next?: DocumentSearchRequest;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentFindRequest
 */
export interface DocumentFindRequest {
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentFindResponse
 */
export interface DocumentFindResponse {
    /**
     * @generated from protobuf field: brandguard.document.DocumentMedia media = 1;
     */
    media?: DocumentMedia;
    /**
     * @generated from protobuf field: brandguard.document.DocumentEvent event = 2;
     */
    event?: DocumentEvent;
    /**
     * @generated from protobuf field: repeated brandguard.document.DocumentPage pages = 3;
     */
    pages: DocumentPage[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentScoreRequest
 */
export interface DocumentScoreRequest {
}
/**
 * @generated from protobuf message brandguard.document.DocumentScoreResponse
 */
export interface DocumentScoreResponse {
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentPatchRequest
 */
export interface DocumentPatchRequest {
    /**
     * @generated from protobuf field: brandguard.document.DocumentMedia media = 1;
     */
    media?: DocumentMedia;
    /**
     * @generated from protobuf field: brandguard.document.DocumentEvent event = 2;
     */
    event?: DocumentEvent;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentPatchResponse
 */
export interface DocumentPatchResponse {
    /**
     * @generated from protobuf field: brandguard.document.DocumentMedia media = 1;
     */
    media?: DocumentMedia;
    /**
     * @generated from protobuf field: brandguard.document.DocumentEvent event = 2;
     */
    event?: DocumentEvent;
    /**
     * @generated from protobuf field: repeated brandguard.document.DocumentPage pages = 3;
     */
    pages: DocumentPage[];
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentPagesRequest
 */
export interface DocumentPagesRequest {
    /**
     * @generated from protobuf field: string document_id = 1 [json_name = "document_id"];
     */
    document_id: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentPagesResponse
 */
export interface DocumentPagesResponse {
    /**
     * @generated from protobuf field: repeated brandguard.document.DocumentPage pages = 1;
     */
    pages: DocumentPage[];
}
/**
 * Kernel configuration messages
 *
 * @generated from protobuf message brandguard.document.DocumentKernelSearchRequest
 */
export interface DocumentKernelSearchRequest {
    /**
     * @generated from protobuf field: int64 offset = 1;
     */
    offset: bigint;
    /**
     * @generated from protobuf field: string brand_id = 2 [json_name = "brand_id"];
     */
    brand_id: string;
    /**
     * @generated from protobuf field: uint64 limit = 3;
     */
    limit: bigint;
}
/**
 * @generated from protobuf message brandguard.document.DocumentKernelSearchResponse
 */
export interface DocumentKernelSearchResponse {
    /**
     * @generated from protobuf field: repeated brandguard.kernel.KernelMetadata items = 1;
     */
    items: KernelMetadata[];
    /**
     * @generated from protobuf field: brandguard.document.DocumentKernelSearchRequest next = 2;
     */
    next?: DocumentKernelSearchRequest;
}
/**
 * @generated from protobuf message brandguard.document.DocumentKernelFindRequest
 */
export interface DocumentKernelFindRequest {
}
/**
 * @generated from protobuf message brandguard.document.DocumentKernelFindResponse
 */
export interface DocumentKernelFindResponse {
    /**
     * @generated from protobuf field: brandguard.kernel.KernelMetadata kernel = 1;
     */
    kernel?: KernelMetadata;
}
/**
 * @generated from protobuf message brandguard.document.DocumentKernelSettingsCreateRequest
 */
export interface DocumentKernelSettingsCreateRequest {
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelSetting settings = 1;
     */
    settings?: DocumentKernelSetting;
}
/**
 * @generated from protobuf message brandguard.document.DocumentKernelSettingsCreateResponse
 */
export interface DocumentKernelSettingsCreateResponse {
    /**
     * @generated from protobuf field: brandguard.kernel.KernelMetadata kernel = 1;
     */
    kernel?: KernelMetadata;
}
/**
 * @generated from protobuf message brandguard.document.DocumentKernelSettingsRequest
 */
export interface DocumentKernelSettingsRequest {
}
/**
 * @generated from protobuf message brandguard.document.DocumentKernelSettingsResponse
 */
export interface DocumentKernelSettingsResponse {
    /**
     * @generated from protobuf field: brandguard.kernel.DocumentKernelSetting settings = 1;
     */
    settings?: DocumentKernelSetting;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentVersionHistoryRequest
 */
export interface DocumentVersionHistoryRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * easyjson:json
 *
 * @generated from protobuf message brandguard.document.DocumentVersionHistoryResponse
 */
export interface DocumentVersionHistoryResponse {
    /**
     * @generated from protobuf field: repeated brandguard.document.DocumentSearchResponseItem versions = 1;
     */
    versions: DocumentSearchResponseItem[];
}
// @generated message type with reflection information, may provide speed optimized methods
class DocumentEvent$Type extends MessageType<DocumentEvent> {
    constructor() {
        super("brandguard.document.DocumentEvent", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "account_id", kind: "scalar", localName: "account_id", jsonName: "account_id", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "approved", kind: "enum", T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 5, name: "observation", kind: "enum", T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 6, name: "queue", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 1000, name: "confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1001, name: "page_count", kind: "scalar", localName: "page_count", jsonName: "page_count", T: 5 /*ScalarType.INT32*/ },
            { no: 1002, name: "pages_scored", kind: "scalar", localName: "pages_scored", jsonName: "pages_scored", T: 5 /*ScalarType.INT32*/ },
            { no: 1003, name: "updated_at", kind: "scalar", localName: "updated_at", jsonName: "updated_at", T: 9 /*ScalarType.STRING*/ },
            { no: 1004, name: "doc_brand_voice", kind: "scalar", localName: "doc_brand_voice", jsonName: "doc_brand_voice", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1005, name: "doc_nudity", kind: "scalar", localName: "doc_nudity", jsonName: "doc_nudity", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1006, name: "doc_violence", kind: "scalar", localName: "doc_violence", jsonName: "doc_violence", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1007, name: "doc_racism", kind: "scalar", localName: "doc_racism", jsonName: "doc_racism", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1008, name: "doc_grammar", kind: "scalar", localName: "doc_grammar", jsonName: "doc_grammar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1009, name: "doc_lookandfeel", kind: "scalar", localName: "doc_lookandfeel", jsonName: "doc_lookandfeel", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1010, name: "doc_logo_detection", kind: "scalar", localName: "doc_logo_detection", jsonName: "doc_logo_detection", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1011, name: "doc_font_detection", kind: "scalar", localName: "doc_font_detection", jsonName: "doc_font_detection", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1012, name: "doc_rules", kind: "scalar", localName: "doc_rules", jsonName: "doc_rules", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1013, name: "artifact_score", kind: "scalar", localName: "artifact_score", jsonName: "artifact_score", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1014, name: "artifact_match_description", kind: "scalar", localName: "artifact_match_description", jsonName: "artifact_match_description", T: 9 /*ScalarType.STRING*/ },
            { no: 1015, name: "artifact_match_training_id", kind: "scalar", localName: "artifact_match_training_id", jsonName: "artifact_match_training_id", T: 9 /*ScalarType.STRING*/ },
            { no: 1016, name: "doc_ai_generated", kind: "scalar", localName: "doc_ai_generated", jsonName: "doc_ai_generated", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 1017, name: "doc_ai_generated_explanation", kind: "scalar", localName: "doc_ai_generated_explanation", jsonName: "doc_ai_generated_explanation", T: 9 /*ScalarType.STRING*/ },
            { no: 1018, name: "doc_background_colors", kind: "scalar", localName: "doc_background_colors", jsonName: "doc_background_colors", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentEvent>): DocumentEvent {
        const message = { id: "", account_id: "", brand_id: "", approved: 0, observation: 0, queue: "", confidence: 0, page_count: 0, pages_scored: 0, updated_at: "", doc_brand_voice: 0, doc_nudity: 0, doc_violence: 0, doc_racism: 0, doc_grammar: 0, doc_lookandfeel: 0, doc_logo_detection: 0, doc_font_detection: 0, doc_rules: 0, artifact_score: 0, artifact_match_description: "", artifact_match_training_id: "", doc_ai_generated: 0, doc_ai_generated_explanation: "", doc_background_colors: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentEvent>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentEvent): DocumentEvent {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string account_id = 2 [json_name = "account_id"];*/ 2:
                    message.account_id = reader.string();
                    break;
                case /* string brand_id = 3 [json_name = "brand_id"];*/ 3:
                    message.brand_id = reader.string();
                    break;
                case /* brandguard.approval.Prediction approved */ 4:
                    message.approved = reader.int32();
                    break;
                case /* brandguard.approval.Prediction observation */ 5:
                    message.observation = reader.int32();
                    break;
                case /* string queue */ 6:
                    message.queue = reader.string();
                    break;
                case /* double confidence */ 1000:
                    message.confidence = reader.double();
                    break;
                case /* int32 page_count = 1001 [json_name = "page_count"];*/ 1001:
                    message.page_count = reader.int32();
                    break;
                case /* int32 pages_scored = 1002 [json_name = "pages_scored"];*/ 1002:
                    message.pages_scored = reader.int32();
                    break;
                case /* string updated_at = 1003 [json_name = "updated_at"];*/ 1003:
                    message.updated_at = reader.string();
                    break;
                case /* double doc_brand_voice = 1004 [json_name = "doc_brand_voice"];*/ 1004:
                    message.doc_brand_voice = reader.double();
                    break;
                case /* double doc_nudity = 1005 [json_name = "doc_nudity"];*/ 1005:
                    message.doc_nudity = reader.double();
                    break;
                case /* double doc_violence = 1006 [json_name = "doc_violence"];*/ 1006:
                    message.doc_violence = reader.double();
                    break;
                case /* double doc_racism = 1007 [json_name = "doc_racism"];*/ 1007:
                    message.doc_racism = reader.double();
                    break;
                case /* double doc_grammar = 1008 [json_name = "doc_grammar"];*/ 1008:
                    message.doc_grammar = reader.double();
                    break;
                case /* double doc_lookandfeel = 1009 [json_name = "doc_lookandfeel"];*/ 1009:
                    message.doc_lookandfeel = reader.double();
                    break;
                case /* double doc_logo_detection = 1010 [json_name = "doc_logo_detection"];*/ 1010:
                    message.doc_logo_detection = reader.double();
                    break;
                case /* double doc_font_detection = 1011 [json_name = "doc_font_detection"];*/ 1011:
                    message.doc_font_detection = reader.double();
                    break;
                case /* double doc_rules = 1012 [json_name = "doc_rules"];*/ 1012:
                    message.doc_rules = reader.double();
                    break;
                case /* double artifact_score = 1013 [json_name = "artifact_score"];*/ 1013:
                    message.artifact_score = reader.double();
                    break;
                case /* string artifact_match_description = 1014 [json_name = "artifact_match_description"];*/ 1014:
                    message.artifact_match_description = reader.string();
                    break;
                case /* string artifact_match_training_id = 1015 [json_name = "artifact_match_training_id"];*/ 1015:
                    message.artifact_match_training_id = reader.string();
                    break;
                case /* double doc_ai_generated = 1016 [json_name = "doc_ai_generated"];*/ 1016:
                    message.doc_ai_generated = reader.double();
                    break;
                case /* string doc_ai_generated_explanation = 1017 [json_name = "doc_ai_generated_explanation"];*/ 1017:
                    message.doc_ai_generated_explanation = reader.string();
                    break;
                case /* double doc_background_colors = 1018 [json_name = "doc_background_colors"];*/ 1018:
                    message.doc_background_colors = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentEvent, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string account_id = 2 [json_name = "account_id"]; */
        if (message.account_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.account_id);
        /* string brand_id = 3 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.brand_id);
        /* brandguard.approval.Prediction approved = 4; */
        if (message.approved !== 0)
            writer.tag(4, WireType.Varint).int32(message.approved);
        /* brandguard.approval.Prediction observation = 5; */
        if (message.observation !== 0)
            writer.tag(5, WireType.Varint).int32(message.observation);
        /* string queue = 6; */
        if (message.queue !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.queue);
        /* double confidence = 1000; */
        if (message.confidence !== 0)
            writer.tag(1000, WireType.Bit64).double(message.confidence);
        /* int32 page_count = 1001 [json_name = "page_count"]; */
        if (message.page_count !== 0)
            writer.tag(1001, WireType.Varint).int32(message.page_count);
        /* int32 pages_scored = 1002 [json_name = "pages_scored"]; */
        if (message.pages_scored !== 0)
            writer.tag(1002, WireType.Varint).int32(message.pages_scored);
        /* string updated_at = 1003 [json_name = "updated_at"]; */
        if (message.updated_at !== "")
            writer.tag(1003, WireType.LengthDelimited).string(message.updated_at);
        /* double doc_brand_voice = 1004 [json_name = "doc_brand_voice"]; */
        if (message.doc_brand_voice !== 0)
            writer.tag(1004, WireType.Bit64).double(message.doc_brand_voice);
        /* double doc_nudity = 1005 [json_name = "doc_nudity"]; */
        if (message.doc_nudity !== 0)
            writer.tag(1005, WireType.Bit64).double(message.doc_nudity);
        /* double doc_violence = 1006 [json_name = "doc_violence"]; */
        if (message.doc_violence !== 0)
            writer.tag(1006, WireType.Bit64).double(message.doc_violence);
        /* double doc_racism = 1007 [json_name = "doc_racism"]; */
        if (message.doc_racism !== 0)
            writer.tag(1007, WireType.Bit64).double(message.doc_racism);
        /* double doc_grammar = 1008 [json_name = "doc_grammar"]; */
        if (message.doc_grammar !== 0)
            writer.tag(1008, WireType.Bit64).double(message.doc_grammar);
        /* double doc_lookandfeel = 1009 [json_name = "doc_lookandfeel"]; */
        if (message.doc_lookandfeel !== 0)
            writer.tag(1009, WireType.Bit64).double(message.doc_lookandfeel);
        /* double doc_logo_detection = 1010 [json_name = "doc_logo_detection"]; */
        if (message.doc_logo_detection !== 0)
            writer.tag(1010, WireType.Bit64).double(message.doc_logo_detection);
        /* double doc_font_detection = 1011 [json_name = "doc_font_detection"]; */
        if (message.doc_font_detection !== 0)
            writer.tag(1011, WireType.Bit64).double(message.doc_font_detection);
        /* double doc_rules = 1012 [json_name = "doc_rules"]; */
        if (message.doc_rules !== 0)
            writer.tag(1012, WireType.Bit64).double(message.doc_rules);
        /* double artifact_score = 1013 [json_name = "artifact_score"]; */
        if (message.artifact_score !== 0)
            writer.tag(1013, WireType.Bit64).double(message.artifact_score);
        /* string artifact_match_description = 1014 [json_name = "artifact_match_description"]; */
        if (message.artifact_match_description !== "")
            writer.tag(1014, WireType.LengthDelimited).string(message.artifact_match_description);
        /* string artifact_match_training_id = 1015 [json_name = "artifact_match_training_id"]; */
        if (message.artifact_match_training_id !== "")
            writer.tag(1015, WireType.LengthDelimited).string(message.artifact_match_training_id);
        /* double doc_ai_generated = 1016 [json_name = "doc_ai_generated"]; */
        if (message.doc_ai_generated !== 0)
            writer.tag(1016, WireType.Bit64).double(message.doc_ai_generated);
        /* string doc_ai_generated_explanation = 1017 [json_name = "doc_ai_generated_explanation"]; */
        if (message.doc_ai_generated_explanation !== "")
            writer.tag(1017, WireType.LengthDelimited).string(message.doc_ai_generated_explanation);
        /* double doc_background_colors = 1018 [json_name = "doc_background_colors"]; */
        if (message.doc_background_colors !== 0)
            writer.tag(1018, WireType.Bit64).double(message.doc_background_colors);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentEvent
 */
export const DocumentEvent = new DocumentEvent$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentMedia$Type extends MessageType<DocumentMedia> {
    constructor() {
        super("brandguard.document.DocumentMedia", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "account_id", kind: "scalar", localName: "account_id", jsonName: "account_id", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "uploaded_by", kind: "scalar", localName: "uploaded_by", jsonName: "uploaded_by", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "md5", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mimetype", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "mimetype_md5", kind: "scalar", localName: "mimetype_md5", jsonName: "mimetype_md5", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "created_at", kind: "scalar", localName: "created_at", jsonName: "created_at", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "updated_at", kind: "scalar", localName: "updated_at", jsonName: "updated_at", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "tombstoned_at", kind: "scalar", localName: "tombstoned_at", jsonName: "tombstoned_at", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "scored_at", kind: "scalar", localName: "scored_at", jsonName: "scored_at", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "page_count", kind: "scalar", localName: "page_count", jsonName: "page_count", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "pages_scored", kind: "scalar", localName: "pages_scored", jsonName: "pages_scored", T: 5 /*ScalarType.INT32*/ },
            { no: 15, name: "reviewed_by", kind: "scalar", localName: "reviewed_by", jsonName: "reviewed_by", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "ancestor_id", kind: "scalar", localName: "ancestor_id", jsonName: "ancestor_id", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentMedia>): DocumentMedia {
        const message = { id: "", account_id: "", brand_id: "", uploaded_by: "", md5: "", mimetype: "", mimetype_md5: "", created_at: "", updated_at: "", tombstoned_at: "", scored_at: "", description: "", page_count: 0, pages_scored: 0, reviewed_by: "", ancestor_id: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentMedia>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentMedia): DocumentMedia {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string account_id = 2 [json_name = "account_id"];*/ 2:
                    message.account_id = reader.string();
                    break;
                case /* string brand_id = 3 [json_name = "brand_id"];*/ 3:
                    message.brand_id = reader.string();
                    break;
                case /* string uploaded_by = 4 [json_name = "uploaded_by"];*/ 4:
                    message.uploaded_by = reader.string();
                    break;
                case /* string md5 */ 5:
                    message.md5 = reader.string();
                    break;
                case /* string mimetype */ 6:
                    message.mimetype = reader.string();
                    break;
                case /* string mimetype_md5 = 7 [json_name = "mimetype_md5"];*/ 7:
                    message.mimetype_md5 = reader.string();
                    break;
                case /* string created_at = 8 [json_name = "created_at"];*/ 8:
                    message.created_at = reader.string();
                    break;
                case /* string updated_at = 9 [json_name = "updated_at"];*/ 9:
                    message.updated_at = reader.string();
                    break;
                case /* string tombstoned_at = 10 [json_name = "tombstoned_at"];*/ 10:
                    message.tombstoned_at = reader.string();
                    break;
                case /* string scored_at = 11 [json_name = "scored_at"];*/ 11:
                    message.scored_at = reader.string();
                    break;
                case /* string description */ 12:
                    message.description = reader.string();
                    break;
                case /* int32 page_count = 13 [json_name = "page_count"];*/ 13:
                    message.page_count = reader.int32();
                    break;
                case /* int32 pages_scored = 14 [json_name = "pages_scored"];*/ 14:
                    message.pages_scored = reader.int32();
                    break;
                case /* string reviewed_by = 15 [json_name = "reviewed_by"];*/ 15:
                    message.reviewed_by = reader.string();
                    break;
                case /* string ancestor_id = 16 [json_name = "ancestor_id"];*/ 16:
                    message.ancestor_id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentMedia, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string account_id = 2 [json_name = "account_id"]; */
        if (message.account_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.account_id);
        /* string brand_id = 3 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.brand_id);
        /* string uploaded_by = 4 [json_name = "uploaded_by"]; */
        if (message.uploaded_by !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.uploaded_by);
        /* string md5 = 5; */
        if (message.md5 !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.md5);
        /* string mimetype = 6; */
        if (message.mimetype !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.mimetype);
        /* string mimetype_md5 = 7 [json_name = "mimetype_md5"]; */
        if (message.mimetype_md5 !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.mimetype_md5);
        /* string created_at = 8 [json_name = "created_at"]; */
        if (message.created_at !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.created_at);
        /* string updated_at = 9 [json_name = "updated_at"]; */
        if (message.updated_at !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.updated_at);
        /* string tombstoned_at = 10 [json_name = "tombstoned_at"]; */
        if (message.tombstoned_at !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.tombstoned_at);
        /* string scored_at = 11 [json_name = "scored_at"]; */
        if (message.scored_at !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.scored_at);
        /* string description = 12; */
        if (message.description !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.description);
        /* int32 page_count = 13 [json_name = "page_count"]; */
        if (message.page_count !== 0)
            writer.tag(13, WireType.Varint).int32(message.page_count);
        /* int32 pages_scored = 14 [json_name = "pages_scored"]; */
        if (message.pages_scored !== 0)
            writer.tag(14, WireType.Varint).int32(message.pages_scored);
        /* string reviewed_by = 15 [json_name = "reviewed_by"]; */
        if (message.reviewed_by !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.reviewed_by);
        /* string ancestor_id = 16 [json_name = "ancestor_id"]; */
        if (message.ancestor_id !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.ancestor_id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentMedia
 */
export const DocumentMedia = new DocumentMedia$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentPage$Type extends MessageType<DocumentPage> {
    constructor() {
        super("brandguard.document.DocumentPage", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "document_id", kind: "scalar", localName: "document_id", jsonName: "document_id", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "account_id", kind: "scalar", localName: "account_id", jsonName: "account_id", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "uploaded_by", kind: "scalar", localName: "uploaded_by", jsonName: "uploaded_by", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "page_number", kind: "scalar", localName: "page_number", jsonName: "page_number", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "created_at", kind: "scalar", localName: "created_at", jsonName: "created_at", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "updated_at", kind: "scalar", localName: "updated_at", jsonName: "updated_at", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "scored_at", kind: "scalar", localName: "scored_at", jsonName: "scored_at", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "approved", kind: "enum", T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 11, name: "observation", kind: "enum", T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 12, name: "confidence", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "doc_brand_voice", kind: "scalar", localName: "doc_brand_voice", jsonName: "doc_brand_voice", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "doc_nudity", kind: "scalar", localName: "doc_nudity", jsonName: "doc_nudity", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "doc_violence", kind: "scalar", localName: "doc_violence", jsonName: "doc_violence", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 16, name: "doc_racism", kind: "scalar", localName: "doc_racism", jsonName: "doc_racism", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 17, name: "doc_grammar", kind: "scalar", localName: "doc_grammar", jsonName: "doc_grammar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 18, name: "doc_lookandfeel", kind: "scalar", localName: "doc_lookandfeel", jsonName: "doc_lookandfeel", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 19, name: "doc_logo_detection", kind: "scalar", localName: "doc_logo_detection", jsonName: "doc_logo_detection", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 20, name: "doc_font_detection", kind: "scalar", localName: "doc_font_detection", jsonName: "doc_font_detection", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 21, name: "doc_rules", kind: "scalar", localName: "doc_rules", jsonName: "doc_rules", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 22, name: "page_image_path", kind: "scalar", localName: "page_image_path", jsonName: "page_image_path", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "doc_ai_generated", kind: "scalar", localName: "doc_ai_generated", jsonName: "doc_ai_generated", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 24, name: "doc_ai_generated_explanation", kind: "scalar", localName: "doc_ai_generated_explanation", jsonName: "doc_ai_generated_explanation", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "doc_background_colors", kind: "scalar", localName: "doc_background_colors", jsonName: "doc_background_colors", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentPage>): DocumentPage {
        const message = { id: "", document_id: "", account_id: "", brand_id: "", uploaded_by: "", page_number: 0, created_at: "", updated_at: "", scored_at: "", approved: 0, observation: 0, confidence: 0, doc_brand_voice: 0, doc_nudity: 0, doc_violence: 0, doc_racism: 0, doc_grammar: 0, doc_lookandfeel: 0, doc_logo_detection: 0, doc_font_detection: 0, doc_rules: 0, page_image_path: "", doc_ai_generated: 0, doc_ai_generated_explanation: "", doc_background_colors: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentPage>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentPage): DocumentPage {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string document_id = 2 [json_name = "document_id"];*/ 2:
                    message.document_id = reader.string();
                    break;
                case /* string account_id = 3 [json_name = "account_id"];*/ 3:
                    message.account_id = reader.string();
                    break;
                case /* string brand_id = 4 [json_name = "brand_id"];*/ 4:
                    message.brand_id = reader.string();
                    break;
                case /* string uploaded_by = 5 [json_name = "uploaded_by"];*/ 5:
                    message.uploaded_by = reader.string();
                    break;
                case /* int32 page_number = 6 [json_name = "page_number"];*/ 6:
                    message.page_number = reader.int32();
                    break;
                case /* string created_at = 7 [json_name = "created_at"];*/ 7:
                    message.created_at = reader.string();
                    break;
                case /* string updated_at = 8 [json_name = "updated_at"];*/ 8:
                    message.updated_at = reader.string();
                    break;
                case /* string scored_at = 9 [json_name = "scored_at"];*/ 9:
                    message.scored_at = reader.string();
                    break;
                case /* brandguard.approval.Prediction approved */ 10:
                    message.approved = reader.int32();
                    break;
                case /* brandguard.approval.Prediction observation */ 11:
                    message.observation = reader.int32();
                    break;
                case /* double confidence */ 12:
                    message.confidence = reader.double();
                    break;
                case /* double doc_brand_voice = 13 [json_name = "doc_brand_voice"];*/ 13:
                    message.doc_brand_voice = reader.double();
                    break;
                case /* double doc_nudity = 14 [json_name = "doc_nudity"];*/ 14:
                    message.doc_nudity = reader.double();
                    break;
                case /* double doc_violence = 15 [json_name = "doc_violence"];*/ 15:
                    message.doc_violence = reader.double();
                    break;
                case /* double doc_racism = 16 [json_name = "doc_racism"];*/ 16:
                    message.doc_racism = reader.double();
                    break;
                case /* double doc_grammar = 17 [json_name = "doc_grammar"];*/ 17:
                    message.doc_grammar = reader.double();
                    break;
                case /* double doc_lookandfeel = 18 [json_name = "doc_lookandfeel"];*/ 18:
                    message.doc_lookandfeel = reader.double();
                    break;
                case /* double doc_logo_detection = 19 [json_name = "doc_logo_detection"];*/ 19:
                    message.doc_logo_detection = reader.double();
                    break;
                case /* double doc_font_detection = 20 [json_name = "doc_font_detection"];*/ 20:
                    message.doc_font_detection = reader.double();
                    break;
                case /* double doc_rules = 21 [json_name = "doc_rules"];*/ 21:
                    message.doc_rules = reader.double();
                    break;
                case /* string page_image_path = 22 [json_name = "page_image_path"];*/ 22:
                    message.page_image_path = reader.string();
                    break;
                case /* double doc_ai_generated = 23 [json_name = "doc_ai_generated"];*/ 23:
                    message.doc_ai_generated = reader.double();
                    break;
                case /* string doc_ai_generated_explanation = 24 [json_name = "doc_ai_generated_explanation"];*/ 24:
                    message.doc_ai_generated_explanation = reader.string();
                    break;
                case /* double doc_background_colors = 25 [json_name = "doc_background_colors"];*/ 25:
                    message.doc_background_colors = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentPage, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string document_id = 2 [json_name = "document_id"]; */
        if (message.document_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.document_id);
        /* string account_id = 3 [json_name = "account_id"]; */
        if (message.account_id !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.account_id);
        /* string brand_id = 4 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.brand_id);
        /* string uploaded_by = 5 [json_name = "uploaded_by"]; */
        if (message.uploaded_by !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.uploaded_by);
        /* int32 page_number = 6 [json_name = "page_number"]; */
        if (message.page_number !== 0)
            writer.tag(6, WireType.Varint).int32(message.page_number);
        /* string created_at = 7 [json_name = "created_at"]; */
        if (message.created_at !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.created_at);
        /* string updated_at = 8 [json_name = "updated_at"]; */
        if (message.updated_at !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.updated_at);
        /* string scored_at = 9 [json_name = "scored_at"]; */
        if (message.scored_at !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.scored_at);
        /* brandguard.approval.Prediction approved = 10; */
        if (message.approved !== 0)
            writer.tag(10, WireType.Varint).int32(message.approved);
        /* brandguard.approval.Prediction observation = 11; */
        if (message.observation !== 0)
            writer.tag(11, WireType.Varint).int32(message.observation);
        /* double confidence = 12; */
        if (message.confidence !== 0)
            writer.tag(12, WireType.Bit64).double(message.confidence);
        /* double doc_brand_voice = 13 [json_name = "doc_brand_voice"]; */
        if (message.doc_brand_voice !== 0)
            writer.tag(13, WireType.Bit64).double(message.doc_brand_voice);
        /* double doc_nudity = 14 [json_name = "doc_nudity"]; */
        if (message.doc_nudity !== 0)
            writer.tag(14, WireType.Bit64).double(message.doc_nudity);
        /* double doc_violence = 15 [json_name = "doc_violence"]; */
        if (message.doc_violence !== 0)
            writer.tag(15, WireType.Bit64).double(message.doc_violence);
        /* double doc_racism = 16 [json_name = "doc_racism"]; */
        if (message.doc_racism !== 0)
            writer.tag(16, WireType.Bit64).double(message.doc_racism);
        /* double doc_grammar = 17 [json_name = "doc_grammar"]; */
        if (message.doc_grammar !== 0)
            writer.tag(17, WireType.Bit64).double(message.doc_grammar);
        /* double doc_lookandfeel = 18 [json_name = "doc_lookandfeel"]; */
        if (message.doc_lookandfeel !== 0)
            writer.tag(18, WireType.Bit64).double(message.doc_lookandfeel);
        /* double doc_logo_detection = 19 [json_name = "doc_logo_detection"]; */
        if (message.doc_logo_detection !== 0)
            writer.tag(19, WireType.Bit64).double(message.doc_logo_detection);
        /* double doc_font_detection = 20 [json_name = "doc_font_detection"]; */
        if (message.doc_font_detection !== 0)
            writer.tag(20, WireType.Bit64).double(message.doc_font_detection);
        /* double doc_rules = 21 [json_name = "doc_rules"]; */
        if (message.doc_rules !== 0)
            writer.tag(21, WireType.Bit64).double(message.doc_rules);
        /* string page_image_path = 22 [json_name = "page_image_path"]; */
        if (message.page_image_path !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.page_image_path);
        /* double doc_ai_generated = 23 [json_name = "doc_ai_generated"]; */
        if (message.doc_ai_generated !== 0)
            writer.tag(23, WireType.Bit64).double(message.doc_ai_generated);
        /* string doc_ai_generated_explanation = 24 [json_name = "doc_ai_generated_explanation"]; */
        if (message.doc_ai_generated_explanation !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.doc_ai_generated_explanation);
        /* double doc_background_colors = 25 [json_name = "doc_background_colors"]; */
        if (message.doc_background_colors !== 0)
            writer.tag(25, WireType.Bit64).double(message.doc_background_colors);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentPage
 */
export const DocumentPage = new DocumentPage$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentUploadRequest$Type extends MessageType<DocumentUploadRequest> {
    constructor() {
        super("brandguard.document.DocumentUploadRequest", []);
    }
    create(value?: PartialMessage<DocumentUploadRequest>): DocumentUploadRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentUploadRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentUploadRequest): DocumentUploadRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: DocumentUploadRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentUploadRequest
 */
export const DocumentUploadRequest = new DocumentUploadRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentUploadResponse$Type extends MessageType<DocumentUploadResponse> {
    constructor() {
        super("brandguard.document.DocumentUploadResponse", [
            { no: 1, name: "media", kind: "message", T: () => DocumentMedia },
            { no: 2, name: "event", kind: "message", T: () => DocumentEvent },
            { no: 3, name: "pages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentPage }
        ]);
    }
    create(value?: PartialMessage<DocumentUploadResponse>): DocumentUploadResponse {
        const message = { pages: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentUploadResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentUploadResponse): DocumentUploadResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.document.DocumentMedia media */ 1:
                    message.media = DocumentMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* brandguard.document.DocumentEvent event */ 2:
                    message.event = DocumentEvent.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                case /* repeated brandguard.document.DocumentPage pages */ 3:
                    message.pages.push(DocumentPage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentUploadResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.document.DocumentMedia media = 1; */
        if (message.media)
            DocumentMedia.internalBinaryWrite(message.media, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.document.DocumentEvent event = 2; */
        if (message.event)
            DocumentEvent.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated brandguard.document.DocumentPage pages = 3; */
        for (let i = 0; i < message.pages.length; i++)
            DocumentPage.internalBinaryWrite(message.pages[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentUploadResponse
 */
export const DocumentUploadResponse = new DocumentUploadResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentSearchRequest$Type extends MessageType<DocumentSearchRequest> {
    constructor() {
        super("brandguard.document.DocumentSearchRequest", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "queues", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "deprecated_uploaded_by", kind: "scalar", localName: "deprecated_uploaded_by", jsonName: "uploaded_by", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created", kind: "message", T: () => DateRange },
            { no: 6, name: "limit", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 7, name: "observation", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 8, name: "approved", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["brandguard.approval.Prediction", Prediction] },
            { no: 9, name: "confidence", kind: "message", T: () => FloatRange },
            { no: 10, name: "uploaded_by", kind: "scalar", localName: "uploaded_by", jsonName: "uploaders", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "before", kind: "message", T: () => Keyset }
        ]);
    }
    create(value?: PartialMessage<DocumentSearchRequest>): DocumentSearchRequest {
        const message = { offset: 0n, queues: [], deprecated_uploaded_by: "", brand_id: "", limit: 0n, observation: [], approved: [], uploaded_by: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentSearchRequest): DocumentSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* repeated string queues */ 2:
                    message.queues.push(reader.string());
                    break;
                case /* string deprecated_uploaded_by = 3 [deprecated = true, json_name = "uploaded_by"];*/ 3:
                    message.deprecated_uploaded_by = reader.string();
                    break;
                case /* string brand_id = 4 [json_name = "brand_id"];*/ 4:
                    message.brand_id = reader.string();
                    break;
                case /* meta.DateRange created */ 5:
                    message.created = DateRange.internalBinaryRead(reader, reader.uint32(), options, message.created);
                    break;
                case /* uint64 limit */ 6:
                    message.limit = reader.uint64().toBigInt();
                    break;
                case /* repeated brandguard.approval.Prediction observation */ 7:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.observation.push(reader.int32());
                    else
                        message.observation.push(reader.int32());
                    break;
                case /* repeated brandguard.approval.Prediction approved */ 8:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.approved.push(reader.int32());
                    else
                        message.approved.push(reader.int32());
                    break;
                case /* meta.FloatRange confidence */ 9:
                    message.confidence = FloatRange.internalBinaryRead(reader, reader.uint32(), options, message.confidence);
                    break;
                case /* repeated string uploaded_by = 10 [json_name = "uploaders"];*/ 10:
                    message.uploaded_by.push(reader.string());
                    break;
                case /* meta.Keyset before */ 11:
                    message.before = Keyset.internalBinaryRead(reader, reader.uint32(), options, message.before);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* repeated string queues = 2; */
        for (let i = 0; i < message.queues.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.queues[i]);
        /* string deprecated_uploaded_by = 3 [deprecated = true, json_name = "uploaded_by"]; */
        if (message.deprecated_uploaded_by !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.deprecated_uploaded_by);
        /* string brand_id = 4 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.brand_id);
        /* meta.DateRange created = 5; */
        if (message.created)
            DateRange.internalBinaryWrite(message.created, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* uint64 limit = 6; */
        if (message.limit !== 0n)
            writer.tag(6, WireType.Varint).uint64(message.limit);
        /* repeated brandguard.approval.Prediction observation = 7; */
        if (message.observation.length) {
            writer.tag(7, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.observation.length; i++)
                writer.int32(message.observation[i]);
            writer.join();
        }
        /* repeated brandguard.approval.Prediction approved = 8; */
        if (message.approved.length) {
            writer.tag(8, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.approved.length; i++)
                writer.int32(message.approved[i]);
            writer.join();
        }
        /* meta.FloatRange confidence = 9; */
        if (message.confidence)
            FloatRange.internalBinaryWrite(message.confidence, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated string uploaded_by = 10 [json_name = "uploaders"]; */
        for (let i = 0; i < message.uploaded_by.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.uploaded_by[i]);
        /* meta.Keyset before = 11; */
        if (message.before)
            Keyset.internalBinaryWrite(message.before, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentSearchRequest
 */
export const DocumentSearchRequest = new DocumentSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentSearchResponseItem$Type extends MessageType<DocumentSearchResponseItem> {
    constructor() {
        super("brandguard.document.DocumentSearchResponseItem", [
            { no: 1, name: "media", kind: "message", T: () => DocumentMedia },
            { no: 2, name: "event", kind: "message", T: () => DocumentEvent },
            { no: 3, name: "pages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentPage }
        ]);
    }
    create(value?: PartialMessage<DocumentSearchResponseItem>): DocumentSearchResponseItem {
        const message = { pages: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentSearchResponseItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentSearchResponseItem): DocumentSearchResponseItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.document.DocumentMedia media */ 1:
                    message.media = DocumentMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* brandguard.document.DocumentEvent event */ 2:
                    message.event = DocumentEvent.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                case /* repeated brandguard.document.DocumentPage pages */ 3:
                    message.pages.push(DocumentPage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentSearchResponseItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.document.DocumentMedia media = 1; */
        if (message.media)
            DocumentMedia.internalBinaryWrite(message.media, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.document.DocumentEvent event = 2; */
        if (message.event)
            DocumentEvent.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated brandguard.document.DocumentPage pages = 3; */
        for (let i = 0; i < message.pages.length; i++)
            DocumentPage.internalBinaryWrite(message.pages[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentSearchResponseItem
 */
export const DocumentSearchResponseItem = new DocumentSearchResponseItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentSearchResponse$Type extends MessageType<DocumentSearchResponse> {
    constructor() {
        super("brandguard.document.DocumentSearchResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentSearchResponseItem },
            { no: 2, name: "next", kind: "message", T: () => DocumentSearchRequest }
        ]);
    }
    create(value?: PartialMessage<DocumentSearchResponse>): DocumentSearchResponse {
        const message = { items: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentSearchResponse): DocumentSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.document.DocumentSearchResponseItem items */ 1:
                    message.items.push(DocumentSearchResponseItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* brandguard.document.DocumentSearchRequest next */ 2:
                    message.next = DocumentSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.next);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.document.DocumentSearchResponseItem items = 1; */
        for (let i = 0; i < message.items.length; i++)
            DocumentSearchResponseItem.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.document.DocumentSearchRequest next = 2; */
        if (message.next)
            DocumentSearchRequest.internalBinaryWrite(message.next, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentSearchResponse
 */
export const DocumentSearchResponse = new DocumentSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentFindRequest$Type extends MessageType<DocumentFindRequest> {
    constructor() {
        super("brandguard.document.DocumentFindRequest", []);
    }
    create(value?: PartialMessage<DocumentFindRequest>): DocumentFindRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentFindRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentFindRequest): DocumentFindRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: DocumentFindRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentFindRequest
 */
export const DocumentFindRequest = new DocumentFindRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentFindResponse$Type extends MessageType<DocumentFindResponse> {
    constructor() {
        super("brandguard.document.DocumentFindResponse", [
            { no: 1, name: "media", kind: "message", T: () => DocumentMedia },
            { no: 2, name: "event", kind: "message", T: () => DocumentEvent },
            { no: 3, name: "pages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentPage }
        ]);
    }
    create(value?: PartialMessage<DocumentFindResponse>): DocumentFindResponse {
        const message = { pages: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentFindResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentFindResponse): DocumentFindResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.document.DocumentMedia media */ 1:
                    message.media = DocumentMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* brandguard.document.DocumentEvent event */ 2:
                    message.event = DocumentEvent.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                case /* repeated brandguard.document.DocumentPage pages */ 3:
                    message.pages.push(DocumentPage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentFindResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.document.DocumentMedia media = 1; */
        if (message.media)
            DocumentMedia.internalBinaryWrite(message.media, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.document.DocumentEvent event = 2; */
        if (message.event)
            DocumentEvent.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated brandguard.document.DocumentPage pages = 3; */
        for (let i = 0; i < message.pages.length; i++)
            DocumentPage.internalBinaryWrite(message.pages[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentFindResponse
 */
export const DocumentFindResponse = new DocumentFindResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentScoreRequest$Type extends MessageType<DocumentScoreRequest> {
    constructor() {
        super("brandguard.document.DocumentScoreRequest", []);
    }
    create(value?: PartialMessage<DocumentScoreRequest>): DocumentScoreRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentScoreRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentScoreRequest): DocumentScoreRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: DocumentScoreRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentScoreRequest
 */
export const DocumentScoreRequest = new DocumentScoreRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentScoreResponse$Type extends MessageType<DocumentScoreResponse> {
    constructor() {
        super("brandguard.document.DocumentScoreResponse", []);
    }
    create(value?: PartialMessage<DocumentScoreResponse>): DocumentScoreResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentScoreResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentScoreResponse): DocumentScoreResponse {
        return target ?? this.create();
    }
    internalBinaryWrite(message: DocumentScoreResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentScoreResponse
 */
export const DocumentScoreResponse = new DocumentScoreResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentPatchRequest$Type extends MessageType<DocumentPatchRequest> {
    constructor() {
        super("brandguard.document.DocumentPatchRequest", [
            { no: 1, name: "media", kind: "message", T: () => DocumentMedia },
            { no: 2, name: "event", kind: "message", T: () => DocumentEvent }
        ]);
    }
    create(value?: PartialMessage<DocumentPatchRequest>): DocumentPatchRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentPatchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentPatchRequest): DocumentPatchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.document.DocumentMedia media */ 1:
                    message.media = DocumentMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* brandguard.document.DocumentEvent event */ 2:
                    message.event = DocumentEvent.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentPatchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.document.DocumentMedia media = 1; */
        if (message.media)
            DocumentMedia.internalBinaryWrite(message.media, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.document.DocumentEvent event = 2; */
        if (message.event)
            DocumentEvent.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentPatchRequest
 */
export const DocumentPatchRequest = new DocumentPatchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentPatchResponse$Type extends MessageType<DocumentPatchResponse> {
    constructor() {
        super("brandguard.document.DocumentPatchResponse", [
            { no: 1, name: "media", kind: "message", T: () => DocumentMedia },
            { no: 2, name: "event", kind: "message", T: () => DocumentEvent },
            { no: 3, name: "pages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentPage }
        ]);
    }
    create(value?: PartialMessage<DocumentPatchResponse>): DocumentPatchResponse {
        const message = { pages: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentPatchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentPatchResponse): DocumentPatchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.document.DocumentMedia media */ 1:
                    message.media = DocumentMedia.internalBinaryRead(reader, reader.uint32(), options, message.media);
                    break;
                case /* brandguard.document.DocumentEvent event */ 2:
                    message.event = DocumentEvent.internalBinaryRead(reader, reader.uint32(), options, message.event);
                    break;
                case /* repeated brandguard.document.DocumentPage pages */ 3:
                    message.pages.push(DocumentPage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentPatchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.document.DocumentMedia media = 1; */
        if (message.media)
            DocumentMedia.internalBinaryWrite(message.media, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.document.DocumentEvent event = 2; */
        if (message.event)
            DocumentEvent.internalBinaryWrite(message.event, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated brandguard.document.DocumentPage pages = 3; */
        for (let i = 0; i < message.pages.length; i++)
            DocumentPage.internalBinaryWrite(message.pages[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentPatchResponse
 */
export const DocumentPatchResponse = new DocumentPatchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentPagesRequest$Type extends MessageType<DocumentPagesRequest> {
    constructor() {
        super("brandguard.document.DocumentPagesRequest", [
            { no: 1, name: "document_id", kind: "scalar", localName: "document_id", jsonName: "document_id", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentPagesRequest>): DocumentPagesRequest {
        const message = { document_id: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentPagesRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentPagesRequest): DocumentPagesRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string document_id = 1 [json_name = "document_id"];*/ 1:
                    message.document_id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentPagesRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string document_id = 1 [json_name = "document_id"]; */
        if (message.document_id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.document_id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentPagesRequest
 */
export const DocumentPagesRequest = new DocumentPagesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentPagesResponse$Type extends MessageType<DocumentPagesResponse> {
    constructor() {
        super("brandguard.document.DocumentPagesResponse", [
            { no: 1, name: "pages", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentPage }
        ]);
    }
    create(value?: PartialMessage<DocumentPagesResponse>): DocumentPagesResponse {
        const message = { pages: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentPagesResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentPagesResponse): DocumentPagesResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.document.DocumentPage pages */ 1:
                    message.pages.push(DocumentPage.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentPagesResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.document.DocumentPage pages = 1; */
        for (let i = 0; i < message.pages.length; i++)
            DocumentPage.internalBinaryWrite(message.pages[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentPagesResponse
 */
export const DocumentPagesResponse = new DocumentPagesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelSearchRequest$Type extends MessageType<DocumentKernelSearchRequest> {
    constructor() {
        super("brandguard.document.DocumentKernelSearchRequest", [
            { no: 1, name: "offset", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 0 /*LongType.BIGINT*/ },
            { no: 2, name: "brand_id", kind: "scalar", localName: "brand_id", jsonName: "brand_id", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "limit", kind: "scalar", T: 4 /*ScalarType.UINT64*/, L: 0 /*LongType.BIGINT*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelSearchRequest>): DocumentKernelSearchRequest {
        const message = { offset: 0n, brand_id: "", limit: 0n };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelSearchRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelSearchRequest): DocumentKernelSearchRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 offset */ 1:
                    message.offset = reader.int64().toBigInt();
                    break;
                case /* string brand_id = 2 [json_name = "brand_id"];*/ 2:
                    message.brand_id = reader.string();
                    break;
                case /* uint64 limit */ 3:
                    message.limit = reader.uint64().toBigInt();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelSearchRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 offset = 1; */
        if (message.offset !== 0n)
            writer.tag(1, WireType.Varint).int64(message.offset);
        /* string brand_id = 2 [json_name = "brand_id"]; */
        if (message.brand_id !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.brand_id);
        /* uint64 limit = 3; */
        if (message.limit !== 0n)
            writer.tag(3, WireType.Varint).uint64(message.limit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentKernelSearchRequest
 */
export const DocumentKernelSearchRequest = new DocumentKernelSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelSearchResponse$Type extends MessageType<DocumentKernelSearchResponse> {
    constructor() {
        super("brandguard.document.DocumentKernelSearchResponse", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => KernelMetadata },
            { no: 2, name: "next", kind: "message", T: () => DocumentKernelSearchRequest }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelSearchResponse>): DocumentKernelSearchResponse {
        const message = { items: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelSearchResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelSearchResponse): DocumentKernelSearchResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.kernel.KernelMetadata items */ 1:
                    message.items.push(KernelMetadata.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* brandguard.document.DocumentKernelSearchRequest next */ 2:
                    message.next = DocumentKernelSearchRequest.internalBinaryRead(reader, reader.uint32(), options, message.next);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelSearchResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.kernel.KernelMetadata items = 1; */
        for (let i = 0; i < message.items.length; i++)
            KernelMetadata.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* brandguard.document.DocumentKernelSearchRequest next = 2; */
        if (message.next)
            DocumentKernelSearchRequest.internalBinaryWrite(message.next, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentKernelSearchResponse
 */
export const DocumentKernelSearchResponse = new DocumentKernelSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelFindRequest$Type extends MessageType<DocumentKernelFindRequest> {
    constructor() {
        super("brandguard.document.DocumentKernelFindRequest", []);
    }
    create(value?: PartialMessage<DocumentKernelFindRequest>): DocumentKernelFindRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelFindRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelFindRequest): DocumentKernelFindRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: DocumentKernelFindRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentKernelFindRequest
 */
export const DocumentKernelFindRequest = new DocumentKernelFindRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelFindResponse$Type extends MessageType<DocumentKernelFindResponse> {
    constructor() {
        super("brandguard.document.DocumentKernelFindResponse", [
            { no: 1, name: "kernel", kind: "message", T: () => KernelMetadata }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelFindResponse>): DocumentKernelFindResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelFindResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelFindResponse): DocumentKernelFindResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.kernel.KernelMetadata kernel */ 1:
                    message.kernel = KernelMetadata.internalBinaryRead(reader, reader.uint32(), options, message.kernel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelFindResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.kernel.KernelMetadata kernel = 1; */
        if (message.kernel)
            KernelMetadata.internalBinaryWrite(message.kernel, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentKernelFindResponse
 */
export const DocumentKernelFindResponse = new DocumentKernelFindResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelSettingsCreateRequest$Type extends MessageType<DocumentKernelSettingsCreateRequest> {
    constructor() {
        super("brandguard.document.DocumentKernelSettingsCreateRequest", [
            { no: 1, name: "settings", kind: "message", T: () => DocumentKernelSetting }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelSettingsCreateRequest>): DocumentKernelSettingsCreateRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelSettingsCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelSettingsCreateRequest): DocumentKernelSettingsCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.kernel.DocumentKernelSetting settings */ 1:
                    message.settings = DocumentKernelSetting.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelSettingsCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.kernel.DocumentKernelSetting settings = 1; */
        if (message.settings)
            DocumentKernelSetting.internalBinaryWrite(message.settings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentKernelSettingsCreateRequest
 */
export const DocumentKernelSettingsCreateRequest = new DocumentKernelSettingsCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelSettingsCreateResponse$Type extends MessageType<DocumentKernelSettingsCreateResponse> {
    constructor() {
        super("brandguard.document.DocumentKernelSettingsCreateResponse", [
            { no: 1, name: "kernel", kind: "message", T: () => KernelMetadata }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelSettingsCreateResponse>): DocumentKernelSettingsCreateResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelSettingsCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelSettingsCreateResponse): DocumentKernelSettingsCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.kernel.KernelMetadata kernel */ 1:
                    message.kernel = KernelMetadata.internalBinaryRead(reader, reader.uint32(), options, message.kernel);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelSettingsCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.kernel.KernelMetadata kernel = 1; */
        if (message.kernel)
            KernelMetadata.internalBinaryWrite(message.kernel, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentKernelSettingsCreateResponse
 */
export const DocumentKernelSettingsCreateResponse = new DocumentKernelSettingsCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelSettingsRequest$Type extends MessageType<DocumentKernelSettingsRequest> {
    constructor() {
        super("brandguard.document.DocumentKernelSettingsRequest", []);
    }
    create(value?: PartialMessage<DocumentKernelSettingsRequest>): DocumentKernelSettingsRequest {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelSettingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelSettingsRequest): DocumentKernelSettingsRequest {
        return target ?? this.create();
    }
    internalBinaryWrite(message: DocumentKernelSettingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentKernelSettingsRequest
 */
export const DocumentKernelSettingsRequest = new DocumentKernelSettingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentKernelSettingsResponse$Type extends MessageType<DocumentKernelSettingsResponse> {
    constructor() {
        super("brandguard.document.DocumentKernelSettingsResponse", [
            { no: 1, name: "settings", kind: "message", T: () => DocumentKernelSetting }
        ]);
    }
    create(value?: PartialMessage<DocumentKernelSettingsResponse>): DocumentKernelSettingsResponse {
        const message = {};
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentKernelSettingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentKernelSettingsResponse): DocumentKernelSettingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* brandguard.kernel.DocumentKernelSetting settings */ 1:
                    message.settings = DocumentKernelSetting.internalBinaryRead(reader, reader.uint32(), options, message.settings);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentKernelSettingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* brandguard.kernel.DocumentKernelSetting settings = 1; */
        if (message.settings)
            DocumentKernelSetting.internalBinaryWrite(message.settings, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentKernelSettingsResponse
 */
export const DocumentKernelSettingsResponse = new DocumentKernelSettingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentVersionHistoryRequest$Type extends MessageType<DocumentVersionHistoryRequest> {
    constructor() {
        super("brandguard.document.DocumentVersionHistoryRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DocumentVersionHistoryRequest>): DocumentVersionHistoryRequest {
        const message = { id: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentVersionHistoryRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentVersionHistoryRequest): DocumentVersionHistoryRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentVersionHistoryRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentVersionHistoryRequest
 */
export const DocumentVersionHistoryRequest = new DocumentVersionHistoryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DocumentVersionHistoryResponse$Type extends MessageType<DocumentVersionHistoryResponse> {
    constructor() {
        super("brandguard.document.DocumentVersionHistoryResponse", [
            { no: 1, name: "versions", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => DocumentSearchResponseItem }
        ]);
    }
    create(value?: PartialMessage<DocumentVersionHistoryResponse>): DocumentVersionHistoryResponse {
        const message = { versions: [] };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DocumentVersionHistoryResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DocumentVersionHistoryResponse): DocumentVersionHistoryResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated brandguard.document.DocumentSearchResponseItem versions */ 1:
                    message.versions.push(DocumentSearchResponseItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DocumentVersionHistoryResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated brandguard.document.DocumentSearchResponseItem versions = 1; */
        for (let i = 0; i < message.versions.length; i++)
            DocumentSearchResponseItem.internalBinaryWrite(message.versions[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message brandguard.document.DocumentVersionHistoryResponse
 */
export const DocumentVersionHistoryResponse = new DocumentVersionHistoryResponse$Type();
